module.exports = __webpack_public_path__ + "static/x4f-a0ec659eb54bd7ba3a6f7712e06f559b.png";